import React from "react";

const FeatureItem = ({ children }) => (
  <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#7decc6] hover:scale-105 duration-150 hover:shadow-lg ">
    <p className="mb-0 text-lg text-[#364553] font-medium hover:text-[#6ac9a8]">
      {children}
    </p>
  </div>
);

const AllFeatures = () => {
  return (
    <div className="bg-[#f1f5f8] pt-12 px-3 sm:px-12 sm:mt-0 relative flex flex-col items-center">
      <div className="text-center">
        <p className=" text-3xl sm:text-4xl text-black font-bold mb-7">
          Simplify your GST return filing experience with <br />
          <span className="sm:text-[#519980] ">
            Best GST Return Filing Software
          </span>
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 bg-white p-3 sm:p-10 w-full max-w-7xl gap-x-4">
        <div className="space-y-3">
          <FeatureItem>
            Upload & GST Returns <br />
            GSTR-1/ 3B/ 4/ 7/ 9/ 9C, CMP-08
          </FeatureItem>
          <FeatureItem>Intelligent Reconciliation Module</FeatureItem>
          <FeatureItem>e-invoice</FeatureItem>
          <FeatureItem>Advance online Activities on a click</FeatureItem>
          <FeatureItem>Data Import / Export</FeatureItem>
          <FeatureItem>GST Return Statistics dashboard</FeatureItem>
          <FeatureItem>
            Current balance of Cash & <br />
            Credit Ledger
          </FeatureItem>
          <FeatureItem>
            Bulk GSTR 2B Excel download & <br />
            direct E-Mail Facility
          </FeatureItem>
          <FeatureItem>Interest & Penalty calculator</FeatureItem>
          <FeatureItem>User management with access rights</FeatureItem>
          <FeatureItem>Password Security</FeatureItem>
        </div>
        <div className="space-y-3">
          <FeatureItem>
            Annual Return GSTR-9 & <br />
            Audit Report GSTR 9C
          </FeatureItem>
          <FeatureItem>e-invoice reconciliation</FeatureItem>
          <FeatureItem>e-way Bill</FeatureItem>
          <FeatureItem>Get GST Return Filing details on click</FeatureItem>
          <FeatureItem>Tally Data Import</FeatureItem>
          <FeatureItem>Return Pre-Validation Facility</FeatureItem>
          <FeatureItem>
            TDS-TCS Credit <br />
            direct collect
          </FeatureItem>
          <FeatureItem>
            ITC Match / Mismatch <br />
            Reports
          </FeatureItem>
          <FeatureItem>Assessee-wise document storage</FeatureItem>
          <FeatureItem>Data Backup & Restore</FeatureItem>

          <FeatureItem>ITC Reconciliation</FeatureItem>
        </div>
        <div className="space-y-3 mt-3 sm:mt-0">
          <FeatureItem>
            Job work Return <br />
            (ITC-04)
          </FeatureItem>
          <FeatureItem>Comprehensive Dashboard</FeatureItem>
          <FeatureItem>Online Tax Payment</FeatureItem>
          <FeatureItem>GSTIN Validation from GST Portal Directly</FeatureItem>
          <FeatureItem>Manual Data entry </FeatureItem>
          <FeatureItem>JSON Error Viewer Facility</FeatureItem>
          <FeatureItem>
            Bulk Download of GSTR 3B & <br />
            GSTR 1 PDF in Single Click
          </FeatureItem>
          <FeatureItem>
            Multi-Angle Analysis <br />
            Reports
          </FeatureItem>
          <FeatureItem>GST Return calendar</FeatureItem>
          <FeatureItem>E-mail integration</FeatureItem>
          <FeatureItem>Customer Support</FeatureItem>
        </div>
      </div>
      <div className="w-full flex justify-end mt-2 max-w-7xl">
        <a
          href="https://www.easyofficesoftware.com/easygst"
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-end"
        >
          <p className="mb-0 mr-1 text-black text-lg font-bold">Learn More</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-right mt-1"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default AllFeatures;
